import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    close: 'Close',
  },
  fr: {
    close: 'Fermer',
  },
} as const);
